import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Post } from 'src/app/models/post';
import { PostService } from 'src/app/services/blog.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  posts: Post[] = [];
  destaque: Post[] = [];
  postsRecentes: Post[] = [];
  currentPage = 1;
  itemsPerPage = 8;
  totalItems = 0;
  categorias: any[];
  loading = false;
  categoria = "";
  categoriaSlug = "";

  constructor(private postService: PostService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.categoriaSlug = params.get('categoriaSlug') || "";
      this.currentPage = 1;
      this.posts = [];
      this.loadPosts();
    });
  }

  async loadPosts() {
    try {
      const category = this.categoriaSlug || this.route.snapshot.paramMap.get('categoriaSlug');

      if (category) {
        const postagensByCategoria = await this.postService.getPostsByCategorias(category, this.currentPage, this.itemsPerPage);
        this.posts = postagensByCategoria["posts"] as Post[];
        this.totalItems = postagensByCategoria["totalDePosts"];
      } else {
        this.categoria = "";
        const posts = await this.postService.getPosts(this.currentPage, this.itemsPerPage);
        this.posts = posts["posts"] as Post[];
        this.totalItems = posts["totalDePosts"];
      }

      const categorias =  await this.postService.getCategories();
      this.categorias = categorias["listaDeCategorias"];
      const getDestaque = await this.postService.getDestaque();
      this.destaque = getDestaque["posts"] as Post[];
      this.postsRecentes = this.posts.slice(0, 3);

    } catch (error) {
      console.error('Erro ao carregar posts:', error);
    } finally {
      this.loading = false;
    }
  }

  pageChanged(event: any): void {
    this.loading = true;
    this.currentPage = event.page;
    this.posts = [];
    this.loadPosts();
    window.scrollTo({ top: 1700, behavior: 'smooth' });
  }
  navigateToPost(slug: string, id: number) {
    window.scrollTo({ top: 200, behavior: 'smooth' });
    this.router.navigate(['/blog', id, slug], { state: { posts: this.posts } });
  }

  isBlogRoute() {
    return this.router.url === '/blog' && this.categoria === "";
  }

  async getPostsByCategory(categoriaSlug, categoria){
    this.posts = [];
    this.categoria = categoria;
    this.categoriaSlug = categoriaSlug;
    this.loading = true;
    this.currentPage = 1;
    this.itemsPerPage = 8;
    try {
      const postagensByCategoria = await this.postService.getPostsByCategorias(categoriaSlug, this.currentPage, this.itemsPerPage);
      this.posts = postagensByCategoria["posts"] as Post[];
      this.totalItems = postagensByCategoria["totalDePosts"];
    } catch (error) {
      this.loadPosts();
      console.error(error);
    } finally{
      this.loading = false
    }
  }

  loadAllPosts(){
    this.posts = [];
    this.currentPage = 1;
    this.categoria = "";
    this.categoriaSlug = "";
    this.loadPosts();
  }

}
